export enum errorMessages {
  GET_FILTERS_ERROR = 'Не удалось получить фильтры',
  SEARCH_POSTS_ERROR = 'Не удалось получить результаты поиска',
  ADD_FEATURE_ERROR = 'Не удалось создать объект',
  EDIT_FEATURE_ERROR = 'Не удалось изменить объект',
  DELETE_FEATURE_ERROR = 'Не удалось удалить объект',
  GET_GEOSPOOF_ERROR = 'Не удалось получить данные',
  GET_LAYER_CHILDREN_ERROR = 'Не удалось получить список папок',
  ADD_LAYER_ERROR = 'Не удалось создать папку',
  DELETE_LAYER_ERROR = 'Не удалось удалить папку',
  EDIT_LAYER_ERROR = 'Не удалось изменить папку',
  ADD_FEATURE_MEDIA_ERROR = 'Не удалось добавить медиафайлы',
  DELETE_FEATURE_MEDIA_ERROR = 'Не удалось удалить медиафайл',
  ADD_BATCH_FEATURES_ERROR = 'Не удалось сохранить объекты',
  GET_SEARCH_HISTORY_ERROR = 'Не удалось получить историю поиска',
  GET_SEARCH_INFO_ERROR = 'Не удалось получить результат поиска',
  GET_PICTURES_UPLOAD_ID_ERROR = 'Не удалось получить ссылку на загрузку медиафайлов',
  DOWNLOAD_FEATURES_ERROR = 'Не удалось загрузить объекты',
  ADD_REPORT_ERROR = 'Не удалось добавить новый отчет',
  ADD_CLIENT_ERROR = 'Не удалось добавить нового заказчика',
  GET_ATTRIBUTES_ERROR = 'Не удалось получить атрибуты',
  GET_PRIVILEGES_ERROR = 'Не удалось получить роль пользователя',
  GET_IMAGERY_ERROR = 'Не удалось получить снимок',
  GET_IMAGERY_PREVIEW_ERROR = 'Не удалось получить превью снимков',
  UPDATE_IMAGERY_ERROR = 'Не удалось обновить снимок',
  GET_REPORTS_ERROR = 'Не удалось получить список отчетов',
  GET_OPERATIONAL_RANGES_ERROR = 'Не удалось получить данные из Geoconfirmed',
  GET_OPERATIONAL_OBJECTS_ERROR = 'Нет данных по таким датам',
  GET_PARSERS_ERROR = 'Не удалось получить список аккаунтов, выполняющих парсинг',
  ADD_BOOKMARK_ERROR = 'Не удалось добавить в избранное',
  DELETE_BOOKMARK_ERROR = 'Не удалось удалить пост из избранного',
  GET_BOOKMARK_IDS_ERROR = 'Не удалось получить избранные посты',
  TRANSLATION_ERROR = 'Не удалось выполнить перевод',
  BUILD_REPORT_ERROR = 'Не удалось получить отчет по объекту',
  GET_PREDEFINED_TEMPLATES_ERROR = 'Не удалось получить преодпределённые шаблоны сущностей',
  GET_ACCESS_RULE_SUBJECTS_ERROR = 'Не удалось получить список субъектов',
  GET_GROUP_LINKED_USERS_ERROR = 'Не удалось получить список связанных с группой пользователей',
  GET_GROUP_LIST_ERROR = 'Не удалось получить список групп',
  USER_CREATION_ERROR = 'Не удалось создать пользователя',
  USER_UPDATE_ERROR = 'Не удалось обновить пользователя',
  USER_DELETE_ERROR = 'Не удалось деактивировать пользователя',
  USER_PASSWORD_UPDATE_ERROR = 'Не удалось обновить пароль пользователя',
  USER_TO_GROUP_LINK_ERROR = 'Не удалось добавить пользователя в группу',
  USERS_TO_GROUP_LINK_ERROR = 'Не удалось добавить пользователей в группу',
  UPDATE_GROUP_ERROR = 'Не удалось обновить группу',
  GROUP_DELETE_ERROR = 'Не удалось удалить группу',
  DELETE_USER_TO_GROUP_LINK_ERROR = 'Не удалось удалить пользователя из группы',
  ENITIES_IMPORT_ERROR = 'Не удалось импортировать сущности',
  GEOCODER_ERROR = 'Не удалось получить данные',
  GET_TAGS_ERROR = 'Не удалось получить тэги',
  GET_DOCUMENTS_ERROR = 'Не удалось получить документы',
  GET_DOCUMENT_PREVIEW_ERROR = 'Не удалось получить документ для предпросмотра',
  DRAW_FEATURE_ERROR = 'Не удалось создать фигуру',
  IMPORT_FILE_ERROR = 'Недопустимый формат файла, импортировать возможно .kml и .kmz файлы',
  IMPORT_PREVIEW_ERROR = 'Не удалось получить превью для импорта',
  GET_OBJECTS_ERROR = 'Не удалось получить список доступных объектов',
  GET_FIRES_ERROR = 'Ошибка при получении пожаров',
  GET_ENTITY_ERROR = 'Не удалось получить сущность',
  GET_MAP_ENTITIES_ERROR = 'Не удалось получить состояние карты',
  GET_MAP_FILTERED_ENTITIES_ERROR = 'Не удалось получить состояние карты',
  GET_MAP_INSCRIBED_ENTITIES_ERROR = 'Не удалось получить состояние карты',
  GET_GROUP_LINKED_ENTITIES_ERROR = 'Не удалось получить список связанных с группой сущностей',
  ENTITY_EXPORT_ERROR = 'Не удалось экспортировать сущность',
  GET_ENTITY_ACCESS_RULE_ERROR = 'Не удалось получить правила доступа для сущности',
  GET_ENTITY_PICTURES_ERROR = 'Не удалось загрузить медиафайлы',
  ENTITY_CREATION_ERROR = 'Не удалось создать сущность',
  ENTITY_CREATION_PENDING_ERROR = 'Идет создание сущности. Пожалуйста, подождите',
  ENTITY_UPDATE_ERROR = 'Не удалось обновить сущность',
  ENTITY_RELINK_ERROR = 'Не удалось изменить связи сущностей',
  ENTITY_ACCESS_UPDATE_ERROR = 'Не удалось сохранить правила доступа для сущности',
  ENTITY_LAST_ACCESS_RULE_DELETE_ERROR = 'Не удалось удалить последнее правило доступа. Такая операция приведет к удалению сущности!',
  ENTITY_ADD_MEDIA_ERROR = 'Не удалось добавить медиа к сущности',
  ENTITY_REGROUP_ERROR = 'Не удалось разгруппировать папку',
  ENTITIES_UPDATE_ERROR = 'Не удалось обновить сущности',
  ENTITY_DELETE_ERROR = 'Не удалось удалить сущность',
  GET_INTERCEPTIONS_ERROR = 'Не удалось получить перехваты',
  GET_INTERCEPTION_DEPARTMENTS_ERROR = 'Не удалось получить подразделения',
  GET_INTERCEPTION_BY_ID_ERROR = 'Не удалось загрузить перехват',
  UPDATE_INTERCEPTION_NETWORK_ERROR = 'Не удалось обновить радиосеть',
  UPDATE_INTERCEPTION_MEMBER_ERROR = 'Не удалось обновить абонента',
  GET_INTERCEPTION_MEMBER_BY_ID_ERROR = 'Не удалось получить абонента',
  GET_INTERCEPTION_NETWORK_BY_ID_ERROR = 'Не удалось получить радиосеть',
}

export enum successMessages {
  ENTITY_CREATION_SUCCESS = 'Сущность была успешно создана',
  ENTITY_UPDATE_SUCCESS = 'Сущность была успешно обновлена',
  USER_CREATE_SUCCESS = 'Пользователь был успешно создан',
  USER_UPDATE_SUCCESS = 'Пользователь был успешно обновлен',
  USER_DELETE_SUCCESS = 'Пользователь был успешно деактивирован',
  USER_PASSWORD_UPDATE = 'Пароль пользователя был успешно обновлен',
  USER_TO_GROUP_LINK_SUCCESS = 'Пользователь был успешно добавлен в группу',
  USERS_TO_GROUP_LINK_SUCCESS = 'Пользователи были успешно добавлены в группу',
  UPDATE_GROUP_SUCCESS = 'Группа была успешно обновлена',
  GROUP_DELETE_SUCCESS = 'Группа была успешно удалена',
  DELETE_USER_TO_GROUP_LINK_SUCCESS = 'Пользователь был успешно удален из группы',
  ENTITY_ACCESS_UPDATE_SUCCESS = 'Правила доступа успешно обновлены',
  IMPORT_SUCCESS = 'Сущности успешно импортированы',
  GET_DOCUMENTS = 'Документы успешно получены',
  REGROUP_ENTITY_BY_ID_SUCCESS = 'Разгруппировка папки прошла успешно',
}

export enum convertValidationErrors {
  UNCORRECT_TO_XYH = 'Некорректный формат ввода (пример: 48.2394258, 37.4325399)',
  UNCORRECT_TO_WGS = 'Некорректный формат ввода (пример: 5346339, 7383685)',
  GET_RESULT_ERROR = 'Не удалось получить данные',
  UNCORRECT_COORDINATES = 'Неверное значение координат (широта, долгота)',
}

export enum infoMessages {
  ENTITY_EXPORT_STARTED = 'Экспорт в процессе... Не закрывайте страницу',
  TOO_BIG_FILE = 'Файл слишком большой для конвертации, будет загружен оригинал',
}
